import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconErrorOutlineSvg } from "./IconErrorOutlineSvg.mjs";
const IconErrorOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconErrorOutlineSvg, ...iconProps });
};
export {
  IconErrorOutline
};
